import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        label: 'id',
        key: 'ID',
        defaultShow: true,
        type: 'number'
    },
    {
        label: 'name',
        key: 'NAME',
        defaultShow: true
    },
    {
        label: 'type',
        key: 'TYPE',
        defaultShow: true
    },
    {
        label: 'lang',
        key: 'LANG',
        defaultShow: true
    }
];

